import React from "react";
import { Image, Container, Row } from "react-bootstrap";
import "./info.css";
// import VideoPlayer from "react-video-js-player";
import "./video.css";

//Assets2
import playIcon from "../../assets/img/play-icon.svg";
import BgImage from "../../assets/img/search-bg.png";
import applicheckIcon from "../../assets/img/applicheck.svg";
import chatIcon from "../../assets/img/chat-icon.svg";
import settingsIcon from "../../assets/img/settings-icon.svg";
import fastIcon from "../../assets/img/fast-icon.svg";

//Video

//components
import Benefit from "../../components/Benefits/benefits";
import Download from "../../components/Download-section/download-section";
import Footer from "../../components/Footer/Footer";

const Info = () => {
  // const vid = "https://youtu.be/NnLud7fzTVU";
  return (
    <React.Fragment>
      <div className="bg">
        <section id="soon">
          <Container fluid className="pt-5">
            <Container className="playerSection" data-aos="zoom-in">
              {/* <VideoPlayer src={vid} width="720" heigh="420" /> */}
              <iframe
                width="966"
                height="543"
                src="https://www.youtube.com/embed/eE58wQ9d-cI"
                title="dibble -   כל חומרי הבנייה וכלי העבודה באפליקציה אחת"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </Container>
          </Container>
        </section>
        <section id="benefits">
          <Container className="benefits">
            <Container className="right" data-aos="fade-left">
              <Container className="first-benefits">
                <h2 className="display-4 brand-font" data-aos="zoom-in ">
                  Building a world that <br /> fits your world – Together.
                </h2>
                <div className="text-wrapper">
                  <div className="separate"></div>
                  <p className="main-p" style={{ maxWidth: "420px" }}>
                    We’ve decided to bring the new world to construction. Thanks
                    to an innovative system, we can ensure that you get the
                    equipment that is best for you quickly and easily. Our app
                    compares the prices of your shopping cart products and
                    places an order from the POS nearest you. You can pick up
                    the order on your own, but our drivers make sure that you
                    receive your order on site within less than two hours and
                    our customer experience department is always here to answer
                    your questions and provide assistance. Simple, right?
                  </p>
                </div>
              </Container>
              <div className="second-benefits" data-aos="zoom-in">
                <h2 className="display-4 pb-4 brand-font">
                  We’ll be there
                  <br />
                  before the paint dries.
                </h2>
                <div className="features">
                  <Row>
                    <React.Fragment>
                      <Benefit
                        icon={applicheckIcon}
                        title="Excellent financing offers"
                        description={[
                          "Attractive financing and credit packages ",
                          <br key={1} />,
                          "with AppliCheck",
                        ]}
                        show={true}
                        dataAos="fade-left"
                      />
                    </React.Fragment>
                    <Benefit
                      icon={chatIcon}
                      title="Representatives available on chat and mobile"
                      description={[
                        "Customer service available on all platforms, ",
                        <br key={2} />,
                        "saving time and hassle",
                      ]}
                      width="40px"
                      height="38px"
                      dataAos="fade-right"
                    />

                    <Benefit
                      icon={settingsIcon}
                      title="One-stop-shop"
                      description={[
                        "All invoices and receipts ",
                        <br key={3} />,
                        "on one simple and convenient app.",
                      ]}
                      width="40px"
                      height="40px"
                      dataAos="fade-left"
                    />

                    <Benefit
                      icon={fastIcon}
                      title="Super-speedy deliveries"
                      description={[
                        " All you need at the office, on site or at home",
                        "within less than two hours. It works like a charm, flies like a jet ",
                      ]}
                      width="50px"
                      height="31px"
                      dataAos="fade-right"
                    />
                  </Row>
                </div>
              </div>
            </Container>
            <div className="left">
              <div className="bg-image">
                <div>
                  <Image src={BgImage} fluid />
                </div>
              </div>
            </div>
          </Container>
          <Download />
          <Footer />
        </section>
      </div>
    </React.Fragment>
  );
};

export default Info;
